import { Box, CssBaseline } from '@mui/material';
import AppTheme from './shared-theme/AppTheme';
import FullForm from './components/fullform';
import ColorModeIconDropdown from './shared-theme/ColorModeIconDropdown';

function App() {
  return (
    <AppTheme>
      <CssBaseline enableColorScheme />
      <Box sx={{ position: 'fixed', top: '1rem', right: '1rem' }}>
        <ColorModeIconDropdown />
      </Box>
      <FullForm/>
    </AppTheme>
  );
}

export default App;
